import { ParentComponent, createContext, useContext } from 'solid-js'
import { EventBus, createEventBus } from '@solid-primitives/event-bus'

export type EventSearchTriggered = { type: 'searchTriggered' }

export type Events = EventSearchTriggered

const EventBusContext = createContext<EventBus<Events>>()

export const EventBusProvider: ParentComponent = props => {
	const eventBus = createEventBus<Events>()

	return <EventBusContext.Provider value={eventBus}>{props.children}</EventBusContext.Provider>
}

export function useEventBus() {
	const value = useContext(EventBusContext)

	if (value === undefined) {
		throw new Error('useEventBus must be used within a EventBusProvider')
	}

	return value
}
